import { FlowGrid, Paragraph, Separator } from '@fs/zion-ui'
import React from 'react'
import FilterInput from '../../FilterInput'
import ManageIndexesButton from './ManageIndexesButton'
import useGroupSectionsRework from '../hooks/useGroupSectionsRework'

/**
 * Displays a section with a description paragraph, manage indexes button, and a filter input
 * for searching persons by name.
 *
 * @component
 * @param {Object} props
 * @param {string} props.filterValue - Current filter text value
 * @param {string} props.description - Description text to display above the actions
 * @param {Function} props.onFilterChange - Callback when filter value changes
 * @param {boolean} [props.showManageIndexesButton=true] - Whether to show the manage indexes button.
 *   Ignored once the group sections rework is on, which removes the button along with the
 *   Edit Households drag-and-drop path and the bulk checkbox delete.
 * @returns {JSX.Element}
 */
const FilterAndActions = ({ filterValue, description, onFilterChange, showManageIndexesButton = true }) => {
  const groupSectionsRework = useGroupSectionsRework()

  return (
    <>
      <Separator size="xs" />
      <FlowGrid columnCount={1} orientation="vertical" guttersY="xxs">
        <>
          <Paragraph size="sm">{description}</Paragraph>
          {showManageIndexesButton && !groupSectionsRework && <ManageIndexesButton />}
        </>
        <FilterInput filterValue={filterValue} onFilterChange={onFilterChange} textFieldProps={{ dense: true }} />
      </FlowGrid>
      {!groupSectionsRework && <Separator size="xs" />}
    </>
  )
}

export default FilterAndActions
